module.exports = __webpack_public_path__ + "img/1561894304.a6897472.jpg";